
import { Component, Vue } from "vue-property-decorator"
import { Getter, Mutation } from "vuex-class"
import api from "@/services/api"
import vSelect from "vue-select"

enum SearchType {
	RECORD = "RECORD",
	USER = "USER",
	SEARCH = "SEARCH"
}

interface Search {
	itemType: SearchType,
	search: string,
	pageArgument?: any,
	id?: any,
	iconUrl?: any,
	subTitles?: any,
	title?: string
}

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class GlobalSearch extends Vue {
	@Getter("getRecordName") getRecordName!: string;
	@Mutation("setSearch") setSearch!: (search: string) => void;

	public searchResults: any[] = []; // TODO Type
	public selectedItem: any = null; // TODO Type
	private debounceSearch: NodeJS.Timeout | null = null;

	private searchOpen = false
	private searchCloseDebounce: NodeJS.Timeout | null = null

	private isHovering = false
	private searchUnhoverDebounce: NodeJS.Timeout | null = null

	set isOpen (value: boolean) {
		if (this.searchCloseDebounce) {
			clearTimeout(this.searchCloseDebounce)
			this.searchCloseDebounce = null
		}

		this.searchOpen = value
		if (value) {
			this.$emit("update:searchOpen", value)
		} else {
			this.searchCloseDebounce = setTimeout(() => this.$emit("update:searchOpen", false), 500)
		}
	}
	get isOpen (): boolean {
		return this.searchOpen
	}

	set hovering (value: boolean) {
		if (this.searchUnhoverDebounce) {
			clearTimeout(this.searchUnhoverDebounce)
			this.searchUnhoverDebounce = null
		}

		this.isHovering = value
		if (value) {
			this.$emit("update:hovering", value)
		} else {
			this.searchUnhoverDebounce = setTimeout(() => this.$emit("update:hovering", false), 500)
		}
	}
	get hovering (): boolean {
		return this.isHovering
	}

	public goToSearchResult (result: Search): void {
		switch (result.itemType) {
			case SearchType.RECORD: {
				this.$router.push({ path: `/cases/${result.pageArgument}` })
				break
			}
			case SearchType.USER: {
				this.$router.push({ path: `/userprofile/${result.id}` })
				break
			}
			case SearchType.SEARCH:
			default: {
				this.setSearch(result.search)
				this.$router.push({ path: "/search" })
			}
		}
	}

	public pictureUrl (searchResult: Search): string {
		if (searchResult.iconUrl) {
			return searchResult.iconUrl
		} else {
			return api.pictureUrl(searchResult.id)
		}
	}

	public async fetchOptions (search: string, loading: (isLoading: boolean) => void) {
		if (this.debounceSearch) {
			clearTimeout(this.debounceSearch)
			this.debounceSearch = null
			loading(false)
		}
		if (search === "") {
			this.searchResults = []
		} else {
			loading(true)
			this.debounceSearch = setTimeout(async () => {
				this.searchResults = [
					{
						itemType: "SEARCH",
						title: "Advanced search for \"" + search + "\"",
						search: search
					},
					...await api.allSearch(search)
				]
				loading(false)
			}, 500)
		}
	}
}
